import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column justify-center align-center",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = {
  key: 1,
  class: "row justify-content-center g-4"
}
const _hoisted_3 = { class: "card border-0 bg-light rounded-4 overflow-hidden" }
const _hoisted_4 = { class: "course-image position-relative" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-body p-4" }
const _hoisted_7 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_8 = { class: "fs-6 mb-4" }
const _hoisted_9 = ["innerHTML"]

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { subscriptionState } from '../../../stores/subscription'
import PremiumService from '../../../../api/v2/models/pre_service'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'ChangePlan',
  setup(__props) {

const route = useRoute()

// Reactive state
const premiumServicesToChangePlan = ref<PremiumService[]>([])
const isLoading = ref(true)

// Methods
const getPremiumServicesToChangePlan = () => {
  subscriptionState.getPremiumServicesToChangePlan(route.params.subscriptionId as any).then((response) => {
    if (response) {
      premiumServicesToChangePlan.value = response
      isLoading.value = false
    }
  })
}

const localNumber = (number: number) => {
  return new Intl.NumberFormat("ja-JP").format(number)
}

// Lifecycle
onMounted(() => {
  getPremiumServicesToChangePlan()
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_router_link = _resolveComponent("router-link")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_progress_circular, {
          indeterminate: "",
          color: "green",
          size: "48"
        }),
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-4" }, "データを読み込んでいます。しばらくお待ちください...", -1 /* CACHED */))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(premiumServicesToChangePlan.value, (premiumService) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-12 col-md-6 col-lg-4",
            key: premiumService.id
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: premiumService.imageUrl,
                  alt: "英語完成コース",
                  class: "w-100 h-100 object-fit-cover"
                }, null, 8 /* PROPS */, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(premiumService.name), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_8, _toDisplayString(localNumber(premiumService.price)) + "円 / 月", 1 /* TEXT */),
                _createVNode(_component_router_link, {
                  to: `/classroom/subscription/${_ctx.$route.params.subscriptionId}/change-plan/plan-confirm?targetPremiumServiceId=${premiumService.id}`,
                  class: "btn btn-change text-white w-100 py-3 mb-4"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" このプランに変更する ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]),
                _createElementVNode("p", {
                  innerHTML: premiumService.description
                }, null, 8 /* PROPS */, _hoisted_9)
              ])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
}
}

})